import React, { useState, useEffect } from 'react';

import appService from '../../service/app.service';
import { ButtonUI, DialogUI, FormLabelUI, SelectUI } from '../Interface';

const DocRoleModify = ({
  hasPermission,
  selectedDoc,
  roleDocPermissions,
  roleId,
  setRoleDocPermissions,
  setRefreshPage,
  onHide,
  show,
}) => {
  const [permission, setPermission] = useState(hasPermission);
  const [canCreate, setCanCreate] = useState(true);
  const [canEdit, setCanEdit] = useState(true);
  const [canCopy, setCanCopy] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [canEmailSend, setCanEmailSend] = useState(false);
  const [canSmsSend, setCanSmsSend] = useState(false);

  useEffect(() => {
    setPermission(hasPermission);
    const findedPerm = roleDocPermissions.find((f) => f.documentTypeId === selectedDoc);
    const selectedRolePermission = findedPerm?.roleDocPermissions?.find((permission) => permission.roleId === roleId);
    const canEdit = selectedRolePermission?.canEdit ?? true;

    setCanCreate(selectedRolePermission?.canCreate ?? canEdit);
    setCanEdit(canEdit);

    if (!canEdit) {
      setCanCopy(false);
      setCanDelete(false);
      setCanEmailSend(false);
      setCanSmsSend(false);
    } else {
      setCanCopy(selectedRolePermission?.canCopy ?? false);
      setCanDelete(selectedRolePermission?.canDelete ?? false);
      setCanEmailSend(selectedRolePermission?.canEmailSend ?? false);
      setCanSmsSend(selectedRolePermission?.canSmsSend ?? false);
    }
  }, [selectedDoc, roleId, show, hasPermission, roleDocPermissions]);

  useEffect(() => {
    if (!canEdit) {
      setCanCopy(false);
      setCanDelete(false);
      setCanEmailSend(false);
      setCanSmsSend(false);
    }
  }, [canEdit]);

  const handleChangeRole = async () => {
    appService
      .updateDocPermission(roleId, selectedDoc, permission, canEdit, canCopy, canDelete, canEmailSend, canSmsSend, canCreate)
      .then(() => {
        const updatedDocList = roleDocPermissions.map((documentType) =>
          documentType.documentTypeId === selectedDoc ? { ...documentType, hasPermission: permission } : documentType
        );
        setRoleDocPermissions(updatedDocList);
        setRefreshPage((prev) => !prev);
        onHide();
      })
      .finally(() => {});
  };

  const options = [
    { value: true, label: 'Jogosult' },
    { value: false, label: 'Nem jogosult' },
  ];

  return (
    <DialogUI open={show} headerContent={'Jogosultság módosítás'} fullWidth>
      <div className="flex justify-center flex-wrap">
        <div className="mt-2 mx-2 w-2/5">
          <SelectUI
            value={permission ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              setPermission(value);
            }}
            option={options}
            label={<FormLabelUI text="Jogosultság beállítása" />}
          />
        </div>
        <div className="mt-2 mx-2 w-2/5">
          <SelectUI
            value={canCreate}
            onChange={(e) => setCanCreate(e.target.value)}
            option={options}
            label={<FormLabelUI text="Létrehozhat" />}
          />
        </div>
        <div className="mt-2 mx-2 w-2/5">
          <SelectUI
            value={canEdit ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              setCanEdit(value);
            }}
            option={options}
            label={<FormLabelUI text="Szerkesztheti" />}
          />
        </div>
        <div className="mt-2 mx-2 w-2/5">
          <SelectUI
            value={canCopy ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              setCanCopy(value);
            }}
            option={options}
            label={<FormLabelUI text="Másolhat" />}
            disabled={!canEdit || !canCreate}
          />
        </div>
        <div className="mt-2 mx-2 w-2/5">
          <SelectUI
            value={canDelete ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              setCanDelete(value);
            }}
            option={options}
            label={<FormLabelUI text="Törölhet" />}
            disabled={!canEdit}
          />
        </div>
        <div className="mt-2 mx-2 w-2/5">
          <SelectUI
            value={canEmailSend ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              setCanEmailSend(value);
            }}
            option={options}
            label={<FormLabelUI text="E-mail küldés" />}
            disabled={!canEdit}
          />
        </div>
        <div className="mt-2 mx-2 w-2/5">
          <SelectUI
            value={canSmsSend}
            onChange={(e) => setCanSmsSend(e.target.value)}
            option={options}
            label={<FormLabelUI text="SMS küldés" />}
            disabled={!canEdit}
          />
        </div>
      </div>
      <div className="px-4 mt-8 flex justify-center gap-3">
        <ButtonUI text="Hozzáadás" type="button" className="bg-success" onClick={handleChangeRole}>
          Mentés
        </ButtonUI>

        <ButtonUI text="Mégse" type="button" onClick={onHide} color="blue-gray" variant="gradient"></ButtonUI>
      </div>
    </DialogUI>
  );
};

export default DocRoleModify;
